<template>
    <DRow class="justify-content-between mw-100">
        <DCol md="10">
            <DInput
                id="config-options-modal-value"
                v-model="selectedValue"
                readonly
            />
        </DCol>
        <DCol md="2">
            <DButton
                id="open-config-options-modal"
                :label="__('contracts.fulfillment.herold_at.choose')"
                color="primary"
                :disabled="disabled"
                @click="openModal"
            />
        </DCol>
    </DRow>

    <HeroldAtLocationModal
        v-if="name === 'herold_location_id' && (fulfillmentModule === 'herold_at' || fulfillmentModule === 'skyline' || fulfillmentModule === 'yext') && showModal"
        :show-modal="showModal"
        :value="value"
        :fulfillment-module="fulfillmentModule"
        @update:modelValue="updateValue"
        @close-modal="closeModal"
    />
    <HeroldAtZipModal
        v-if="name === 'zip' && fulfillmentModule === 'herold_at' && showModal"
        :show-modal="showModal"
        @update:modelValue="updateValue"
        @close-modal="closeModal"
    />
</template>

<script setup>
import HeroldAtLocationModal from '~@/Components/Fulfillment/Options/HeroldAtLocationModal'
import HeroldAtZipModal from '~@/Components/Fulfillment/Options/HeroldAtZipModal'
import { ref } from 'vue'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
    name: {
        type: String,
        default: null
    },
    value: {
        default: null,
        type: [String, Number]
    },
    displayValue: {
        default: null,
        type: [String, Number]
    },
    fulfillmentModule: {
        type: String,
        default: null
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const showModal = ref(false)

function openModal () {
    showModal.value = true
}

function closeModal () {
    showModal.value = false
}

const selectedValue = ref(props.displayValue)

function updateValue (value) {
    if (typeof value === 'object') {
        selectedValue.value = value.display_value
    } else {
        selectedValue.value = value
    }
    emit('update:modelValue', value)
    showModal.value = false
}
</script>
